import React from "react";
import ReactDOM from "react-dom";
import Entity from "./entity";
import {createEventListener} from "./tools";
import {
    logout,
    clientUpdate,
} from "api";
import tokenStorage from "./tokenStorage";
import {jwtDecode} from "jwt-decode";
import LoginPageKoBridge from "./containers/Authentication/LoginPageKoBridge";
import moment from "moment";

const SOCIALS = ['facebook', 'vk', 'twitter', 'mailru', 'ok', 'linkedin', 'google', 'yandex', 'kaspersky', 'sso'];

export default function($app) {
	let loginPromise;

	this.client = ko.observable(null);
    this.registrationFields = ko.computed(() => {
        return $app.event().registrationFields()
            .map(({required, name}) => ({required: required(), name: name()}));
    });

	this.socialService = ko.computed(() => {
        const icons = {
            sso: $app.event()?.moduleAuth?.ssoIconUrl(),
        };
		return SOCIALS
			.filter(name => $app.event().moduleAuth[name] && $app.event().moduleAuth[name]())
			.map(name => {
				return {
					name,
                    icon: icons[name] ?? null,
					handler: () => window.open(`/api/player/login/${name}?eventKey=${$app.event().eventKey()}`, 'Авторизация',
							'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=400px,height=400px')
				};
			});
	});

	this.isAuthDisabled = ko.computed(() => {
		const authMethods = [...SOCIALS, 'email', 'guest'];
		for (let i = 0; i < authMethods.length; i++) {
			if ($app.event().moduleAuth[authMethods[i]]()) {
				return false;
			}
		}

		return true;
	});

	this.isLoggedIn = ko.computed(() => {
        let client = this.client();
        if (!client) {
            return false;
        }

        return this.registrationFields()
            .filter(({required, name}) => required && !(client[name] && client[name]()) && !client.info()[name])
            .length === 0;
    });

	this.setClient = data => {
		this.client(data?.clientRegistrationId ? new Entity.Client(data) : null);
		return this;
	};

	this.isShow = ko.observable(false);
	this.isShowSettings = ko.observable(false);

	this.sendSettings = async (form) => {
		const data = {
			nickname: form.nickname.value
		};
		const client = await clientUpdate($app.event().eventKey(), data);
        this.setClient(client);
        this.hideSettings();
	};

	this.login = () => {
		if(loginPromise) {
			loginPromise.reject();
		}
		return new Promise((resolve, reject) => {
			loginPromise = {resolve, reject};

			if(this.isLoggedIn()) {
				resolve(this.client());
			} else {
				this.isShow(true);
			}
		});
	};

	this.show = () => {
		if(this.isLoggedIn()) return;
		this.isShow(true);
	};
	this.hide = () => {
		this.isShow(false);
		if(loginPromise) {
			loginPromise.reject();
		}
	};

	this.showSettings = () => this.isShowSettings(true);
	this.hideSettings = () => this.isShowSettings(false);
	this.toggleSettings = () => this.isShowSettings(!this.isShowSettings());

	this.isShow.subscribe(isShow => {
		let $overlayEventStatus = $('#overlay-event-status-idle, #overlay-event-status-pause, #overlay-event-status-stop');

		if(isShow) {
			if($overlayEventStatus.length > 0) {
				$overlayEventStatus.animate({marginLeft: '-100%'});
			}
		} else {
			if($overlayEventStatus.length > 0) {
				$overlayEventStatus.animate({marginLeft: '0'});
			}
		}
	});

	this.logout = async () => {
		await logout($app.event().eventKey());
        this.setClient(null);
	};

	this.parseJWTFromTokenStorage = () => {
		try {
            return jwtDecode(tokenStorage.get());
		} catch (e) {}

        return null;
	};

	createEventListener(this);

	this.isLoggedIn.subscribe((isLoggedIn) => {
        if (isLoggedIn) {
            this.hide();
            if(loginPromise) {
                loginPromise.resolve(this.client());
                loginPromise = null;
            }
        } else if ($app.page() === 'player' && $app.event().moduleAuth.require()) {
            location.reload(true);
        }
    });

	$app.require('embed').on('login', (data) => {
		tokenStorage.set(data.token);
		const jwtPayload = jwtDecode(data.token);
		this.setClient((jwtPayload?.clientRegistrationId ?? jwtPayload?.id) ? jwtPayload : null);
	});

    setTimeout(() => {
        const visible = ko.computed(() => {
            return $app.page() === 'login';
        });
        ReactDOM.render(
            <PageOverlay
                eventName={$app.event().name()}
                timeStart={moment.unix($app.event().timeStart())}
                $locale={$app.require('locale')}
            >
                <LoginPageKoBridge
                    $app={$app}
                    koVisible={visible}
                    onLogin={this.setClient}
                    onWindowResize={() => $app.require('ui').updateContainer()}
                />
            </PageOverlay>,
            document.getElementById('login-page')
        )
    }, 0);

    $app.on('start', () => {
        const playerContainer = document.getElementById('playerContainer');
        const appContainer = document.getElementById('login-page');
        ReactDOM.unmountComponentAtNode(appContainer);
        playerContainer.insertBefore(appContainer, playerContainer.firstChild);
        ReactDOM.render(
            <PlayerOverlay
                onClose={this.hide}
                $locale={$app.require('locale')}
            >
                <LoginPageKoBridge
                    $app={$app}
                    koVisible={this.isShow}
                    onLogin={this.setClient}
                    onWindowResize={() => $app.require('ui').updateContainer()}
                />
            </PlayerOverlay>,
            appContainer
        );

        ko.computed(() => {
            appContainer.style.display = this.isShow() ? 'block' : 'none';
        });
    });

    this.setClient(this.parseJWTFromTokenStorage());
}

const PageOverlay = ({eventName, timeStart, $locale, children}) => (
    <div>
        <div className="scrollable">
            {/* <h1>{eventName}</h1>
            <p>
                {$locale.get('ticketAuth.timeStart', {
                    datetime: timeStart.format('LLL') + ' (UTC' + timeStart.format('Z') + ')'
                })}
            </p>
            <p>{$locale.get('ticketAuth.header')}</p> */}
            {children}
        </div>
    </div>
)

const PlayerOverlay = ({onClose, $locale, children}) => (
    <div>
        <div className="scrollable">
            {onClose && <a className="overlay-close icon-close" onClick={onClose} />}
            {/* <div className="title">{$locale.get('auth.login.authTitle')}</div> */}
            <div className="auth-services">
                {children}
            </div>
        </div>
    </div>
)
